import { Components, Theme } from "@mui/material";

export const vrMenuOverride: Components<Theme>["MuiMenu"] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      marginTop: theme.spacing(1),
      backgroundColor: theme.palette.dsSurface.v300,
      backgroundImage: "none",
      color: theme.palette.dsBase.v200,
      border: `1px solid ${theme.palette.dsBase.v200}10`,
      borderRadius: theme.shape.borderRadius * 3,
    }),
    list: ({ theme }) => ({ padding: theme.spacing(0.5) }),
  },
};

export const vrMenuItemOverride: Components<Theme>["MuiMenuItem"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.textS500,
      borderRadius: theme.shape.borderRadius * 2.5,
      padding: theme.spacing(1.5, 2),
      gap: theme.spacing(2),
      justifyContent: "space-between",
      "&:hover, &.Mui-focusVisible": { backgroundColor: theme.palette.dsSurface.v200 },
      "&.Mui-selected": {
        backgroundColor: theme.palette.dsSurface.v400,
        "&:hover, &.Mui-focusVisible": { backgroundColor: theme.palette.dsSurface.v200 },
      },
    }),
  },
};
